// import React from "react";
// // Corrected: The path needs to go up three levels to reach the 'component' directory, then into 'site'.
// import ListView from "../../../site/list.jsx"; 
// import { listApi, newRecord, tableFields, uriBasePath } from "./module";

// function CustomerList() {
//   return (
//     <ListView
//       listApi={listApi}
//       listHeading={"Customer List"}
//       tableFields={tableFields}
//       newRecord={newRecord}
//       uriBasePath={uriBasePath}
//     />
//   );
// }

// export default CustomerList;











// import React from "react";
// // Corrected: The path needs to go up three levels to reach the 'component' directory, then into 'site'.
// import ListView from "../../../site/list.jsx"; 
// import { listApi, newRecord, tableFields, uriBasePath } from "./module";

// function CustomerList() {
//   return (
//     <ListView
//       listApi={listApi}
//       listHeading={"Customer List"}
//       tableFields={tableFields}
//       newRecord={newRecord}
//       uriBasePath={uriBasePath}
//     />
//   );
// }

// export default CustomerList;



// import React, { useState, useEffect, useMemo } from "react";
// import ListView from "../../../site/list.jsx";
// import { listApi, newRecord, tableFields, uriBasePath } from "./module";

// // Helper function to make authenticated API calls
// const fetchWithAuth = async (url) => {
//   // --- IMPORTANT ---
//   // Ensure this line correctly retrieves your authentication token.
//   // It might be stored in localStorage, sessionStorage, or a global state.
//   const token = localStorage.getItem("authToken"); 

//   if (!token) {
//     console.error("Authentication token not found. API call cancelled.");
//     // Optionally, you could redirect to a login page here.
//     return null; 
//   }

//   const response = await fetch(url, {
//     headers: {
//       Accept: "application/json",
//       Authorization: `Bearer ${token}`,
//     },
//   });

//   if (!response.ok) {
//     throw new Error(`API call failed: ${response.statusText}`);
//   }
//   return response.json();
// };


// function CustomerList() {
//   const [usersMap, setUsersMap] = useState({});

//   useEffect(() => {
//     const fetchUsers = async () => {
//       try {
//         const userApiUrl = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/api/get-column/users/name`;
//         const users = await fetchWithAuth(userApiUrl);

//         // If the fetch failed (e.g., no token), users will be null.
//         if (!users) return;

//         // Create a map for efficient lookups: { "1": "Divyansh", "2": "Varaprasad" }
//         const userMapping = users.reduce((acc, user) => {
//           acc[user.id] = user.value;
//           return acc;
//         }, {});
        
//         console.log("User map created:", userMapping); // For debugging
//         setUsersMap(userMapping);

//       } catch (error) {
//         console.error("Failed to fetch user data:", error);
//       }
//     };

//     fetchUsers();
//   }, []); // Empty array ensures this runs only once on mount

//   const modifiedTableFields = useMemo(() => {
//     return tableFields.map((field) => {
//       if (field.fieldName === "added_by" || field.fieldName === "updated_by") {
//         return {
//           ...field,
//           render: (userId) => {
//             // If there's no userId, display "N/A"
//             if (!userId) return "N/A";
            
//             // --- THIS IS THE FIX ---
//             // Convert the userId (which might be a number) to a string before the lookup.
//             const userName = usersMap[String(userId)];

//             // Return the found name, or the fallback ID if not found.
//             return userName || `ID: ${userId}`;
//           },
//         };
//       }
//       return field;
//     });
//   }, [usersMap]); // Recalculate only when usersMap changes

//   return (
//     <ListView
//       listApi={listApi}
//       listHeading={"Customer List"}
//       tableFields={modifiedTableFields}
//       newRecord={newRecord}
//       uriBasePath={uriBasePath}
//     />
//   );
// }

// export default CustomerList;








// // src/pages/Dashboard/Customer/customer-list.jsx (FINAL VERSION)
// import React, { useState, useEffect, useMemo } from "react";
// import ListView from "../../../site/list.jsx";
// import { listApi, newRecord, tableFields, uriBasePath } from "./module";

// // Helper function to make authenticated API calls
// const fetchWithAuth = async (url) => {
//   // Get the authentication token from localStorage
//   const token = localStorage.getItem("authToken"); 

//   if (!token) {
//     console.error("Authentication token not found. API call cancelled.");
//     return null; 
//   }

//   const response = await fetch(url, {
//     headers: {
//       Accept: "application/json",
//       Authorization: `Bearer ${token}`,
//     },
//   });

//   if (!response.ok) {
//     throw new Error(`API call failed: ${response.statusText}`);
//   }
//   return response.json();
// };

// function CustomerList() {
//   const [usersMap, setUsersMap] = useState({});
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     const fetchUsers = async () => {
//       try {
//         setIsLoading(true);
//         const userApiUrl = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/api/get-column/users/name`;
//         console.log("Fetching users from:", userApiUrl);
        
//         const users = await fetchWithAuth(userApiUrl);
//         console.log("Raw users data:", users);

//         if (!users) {
//           setIsLoading(false);
//           return;
//         }

//         // Create a map for efficient lookups
//         const userMapping = {};
//         users.forEach(user => {
//           console.log(`Mapping user: ID=${user.id} (type: ${typeof user.id}), Name=${user.value}`);
//           // Store with multiple key formats to ensure we catch all variations
//           userMapping[user.id] = user.value;
//           userMapping[String(user.id)] = user.value;
//           userMapping[Number(user.id)] = user.value;
//         });
        
//         console.log("Final user mapping:", userMapping);
//         setUsersMap(userMapping);
//         setIsLoading(false);

//       } catch (error) {
//         console.error("Failed to fetch user data:", error);
//         setIsLoading(false);
//       }
//     };

//     fetchUsers();
//   }, []);

//   const modifiedTableFields = useMemo(() => {
//     console.log("Recalculating table fields. Users map:", usersMap, "Is loading:", isLoading);
    
//     return tableFields.map((field) => {
//       if (field.fieldName === "added_by" || field.fieldName === "updated_by") {
//         return {
//           ...field,
//           render: (userId, rowData) => {
//             console.log(`Rendering ${field.fieldName}: userId=${userId} (type: ${typeof userId}), Row data:`, rowData);
            
//             // Handle null, undefined, or empty values
//             if (!userId || userId === "" || userId === "N/A") {
//               return "N/A";
//             }
            
//             // If still loading users, show loading state
//             if (isLoading) {
//               return "Loading...";
//             }
            
//             // Try different lookup strategies
//             let userName = usersMap[userId] || 
//                           usersMap[String(userId)] || 
//                           usersMap[Number(userId)];

//             // Additional parsing attempts
//             if (!userName && typeof userId === 'string') {
//               const numericId = parseInt(userId, 10);
//               if (!isNaN(numericId)) {
//                 userName = usersMap[numericId];
//               }
//             }

//             console.log(`User lookup result for ID ${userId}:`, userName);
            
//             // Return the found name, or fallback to showing the ID
//             return userName || `ID: ${userId}`;
//           },
//         };
//       }
//       return field;
//     });
//   }, [usersMap, isLoading]);

//   return (
//     <ListView
//       listApi={listApi}
//       listHeading={"Customer List"}
//       tableFields={modifiedTableFields}
//       newRecord={newRecord}
//       uriBasePath={uriBasePath}
//     />
//   );
// }

// export default CustomerList;








// import React, { useState, useEffect, useMemo } from "react";
// import ListView from "../../../site/list.jsx";
// import { listApi, newRecord, tableFields, uriBasePath } from "./module";
// import { getToken } from '../../../../utils/authHelper';
// ;  // Ensure correct path

// const fetchWithAuth = async (url) => {
//   const token = getToken();

//   if (!token) {
//     console.error("Authentication token not found. API call cancelled.");
//     return null;
//   }

//   const response = await fetch(url, {
//     headers: {
//       Accept: "application/json",
//       Authorization: `Bearer ${token}`,
//     },
//   });

//   if (!response.ok) {
//     throw new Error(`API call failed: ${response.statusText}`);
//   }
//   return response.json();
// };

// function CustomerList() {
//   const [usersMap, setUsersMap] = useState({});

//   useEffect(() => {
//     const fetchUsers = async () => {
//       try {
//         const userApiUrl = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/api/get-column/users/name`;
//         const users = await fetchWithAuth(userApiUrl);

//         if (!users) return;

//         const userMapping = users.reduce((acc, user) => {
//           acc[user.id] = user.value;
//           return acc;
//         }, {});

//         console.log("Fetched users:", users);
//         console.log("Users Map:", userMapping);

//         setUsersMap(userMapping);

//       } catch (error) {
//         console.error("Failed to fetch user data:", error);
//       }
//     };

//     fetchUsers();
//   }, []);

//   const modifiedTableFields = useMemo(() => {
//     return tableFields.map((field) => {
//       if (field.fieldName === "added_by" || field.fieldName === "updated_by") {
//         return {
//           ...field,
//           render: (userId) => {
//             if (!userId) return "N/A";
//             const userName = usersMap[String(userId)];
//             return userName || `Unknown User (ID: ${userId})`;
//           },
//         };
//       }
//       return field;
//     });
//   }, [usersMap]);

//   return (
//     <ListView
//       listApi={listApi}
//       listHeading={"Customer List"}
//       tableFields={modifiedTableFields}
//       newRecord={newRecord}
//       uriBasePath={uriBasePath}
//     />
//   );
// }

// export default CustomerList;













import React from "react";
import CustomerManagementEnhanced from "./CustomerManagementEnhanced.jsx";

function CustomerList() {
  return <CustomerManagementEnhanced />;
}

export default CustomerList;














